module.exports = __webpack_public_path__ + "img/img_quilt07@3x.9871768c.png";